var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4344 41.161C31.7201 41.161 40.8689 32.0242 40.8689 20.7534C40.8689 9.48253 31.7201 0.345703 20.4344 0.345703C9.14881 0.345703 0 9.48253 0 20.7534C0 32.0242 9.14881 41.161 20.4344 41.161Z",
    fill: "#BEAFDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.78643 21.1337C10.992 21.1337 12.7799 19.3481 12.7799 17.1454C12.7799 14.9428 10.992 13.1572 8.78643 13.1572C6.5809 13.1572 4.79297 14.9428 4.79297 17.1454C4.79297 19.3481 6.5809 21.1337 8.78643 21.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5345 14.6786C23.74 14.6786 25.5279 12.893 25.5279 10.6904C25.5279 8.48774 23.74 6.70215 21.5345 6.70215C19.3289 6.70215 17.541 8.48774 17.541 10.6904C17.541 12.893 19.3289 14.6786 21.5345 14.6786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.1087 17.9539C10.1122 17.0796 10.6373 16.0409 10.2817 15.6338C9.9261 15.2266 8.82434 15.6053 7.82086 16.4795C6.81739 17.3538 6.29219 18.3925 6.64782 18.7997C7.00344 19.2068 8.10523 18.8281 9.1087 17.9539Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.7139 10.9047C22.932 10.3674 23.7423 9.53119 23.5237 9.03698C23.3052 8.54277 22.1405 8.57769 20.9224 9.115C19.7043 9.65231 18.894 10.4885 19.1126 10.9828C19.3311 11.477 20.4958 11.442 21.7139 10.9047Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.8075 14.7985C36.4361 14.5225 36.4815 13.2442 35.9089 11.9432C35.3363 10.6422 34.3625 9.8113 33.7339 10.0873C33.1053 10.3632 33.0599 11.6416 33.6325 12.9425C34.2051 14.2435 35.1789 15.0744 35.8075 14.7985Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.7757 38.3492C26.917 37.4862 27.5042 36.3408 27.0872 35.7908C26.6703 35.2407 25.407 35.4944 24.2657 36.3574C23.1244 37.2203 22.5372 38.3658 22.9542 38.9158C23.3712 39.4658 24.6344 39.2122 25.7757 38.3492Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.3316 26.0279C38.0473 24.7898 38.1426 23.5065 37.5443 23.1615C36.9461 22.8166 35.8809 23.5406 35.1651 24.7787C34.4494 26.0168 34.3541 27.3001 34.9524 27.6451C35.5506 27.99 36.6158 27.266 37.3316 26.0279Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.8509 33.4445C33.2438 33.1149 34.2439 32.3035 34.0846 31.6322C33.9254 30.9609 32.667 30.6839 31.2741 31.0135C29.8812 31.3431 28.8811 32.1545 29.0403 32.8258C29.1996 33.4971 30.4579 33.7741 31.8509 33.4445Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.78254 35.2085C10.2899 34.7403 9.91359 33.5095 8.94206 32.4595C7.97054 31.4096 6.77167 30.9379 6.26433 31.4061C5.75699 31.8743 6.13328 33.1051 7.10481 34.1551C8.07634 35.2051 9.2752 35.6767 9.78254 35.2085Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.3558 36.9184C18.5444 36.2547 17.5808 35.4004 16.2037 35.0102C14.8265 34.62 13.5573 34.8416 13.3687 35.5053C13.1802 36.169 14.1437 37.0234 15.5209 37.4136C16.898 37.8038 18.1673 37.5821 18.3558 36.9184Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.882 31.6053C24.2414 31.1574 25.168 30.2632 24.9515 29.608C24.7351 28.9529 23.4576 28.7849 22.0982 29.2329C20.7388 29.6808 19.8122 30.575 20.0286 31.2302C20.2451 31.8853 21.5226 32.0533 22.882 31.6053Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M31.0001 24.8463C32.0123 23.8354 32.4369 22.6204 31.9485 22.1326C31.46 21.6448 30.2435 22.0688 29.2312 23.0797C28.219 24.0907 27.7944 25.3056 28.2829 25.7934C28.7713 26.2812 29.9879 25.8572 31.0001 24.8463Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.85683 26.5426C7.45507 26.1976 7.3598 24.9143 6.64404 23.6762C5.92829 22.4381 4.86309 21.7141 4.26485 22.059C3.66661 22.404 3.76188 23.6873 4.47763 24.9254C5.19339 26.1635 6.25859 26.8875 6.85683 26.5426Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M15.9192 30.3221C16.1645 29.6772 15.2785 28.7428 13.9403 28.2351C12.6021 27.7275 11.3184 27.8387 11.0731 28.4836C10.8278 29.1286 11.7137 30.0629 13.052 30.5706C14.3902 31.0783 15.6739 30.967 15.9192 30.3221Z",
    fill: "#9281C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M31.5895 18.0666C32.1238 17.6293 31.8212 16.3784 30.9137 15.2728C30.0063 14.1671 28.8375 13.6253 28.3033 14.0626C27.769 14.5 28.0716 15.7508 28.979 16.8565C29.8865 17.9622 31.0552 18.504 31.5895 18.0666Z",
    fill: "#9281C1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar7);
export default __webpack_public_path__ + "static/media/boba-avatar-7.668d3088.svg";
export { ForwardRef as ReactComponent };